"use client";

import "./App.css";
import { BrowserRouter } from "react-router-dom";
import AppRoutes, { redirectToCanonicalDomain } from "./routes";
import { AuthProvider } from "./components/auth/AuthContext";
redirectToCanonicalDomain();

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
